import { IconButton } from '@mui/material';
import ShortcutIcon from '../Icons/ShortcutIcon';
import React from 'react';

const FieldStatisticsShortcutCell = ({ onClick }) => {
  return (
    <IconButton size={'small'} onClick={onClick}>
      <ShortcutIcon fontSize={'small'} />
    </IconButton>
  );
};

export default FieldStatisticsShortcutCell;
